import { i18nTranslateInit } from '@/utils/utility-lang'

let holder = '--'
let unit = ''
let prefix = false
let cut = false
let colour = { up: '#f13e3a', down: '#34b369', flat: '#59616c' }

const digitjs = function (value, option) {
  const cfg = typeof option === 'object' ? option : {}
  cfg.value = value
  return new Digitjs(cfg)
}

digitjs.holder = (preset) => {
  holder = preset || holder
}

digitjs.colour = (preset) => {
  if (typeof preset === 'object') {
    colour = { ...colour, ...preset }
  }
}

class Digitjs {
  constructor(cfg) {
    this.$value = cfg.value
    this.$holder = cfg.holder ?? holder
    this.$unit = cfg.unit ?? unit
    this.$prefix = cfg.prefix ?? prefix
    this.$cut = cfg.cut ?? cut
    this.$colour = cfg.colour ?? colour
  }

  isNumber(value) {
    if (this.isString(value)) {
      value = Number(value)
    }
    return Number.isFinite(value)
  }

  isString(value) {
    return typeof value === 'string'
  }

  _rounded(value, decimal) {
    const p1 = 10 ** (decimal + 1)
    const p2 = 10 ** decimal
    const result = Math.round((value * p1) / 10) / p2
    if (this.$cut) {
      return String(+result.toFixed(decimal))
    } else {
      return result.toFixed(decimal)
    }
  }

  _prefix(value) {
    return Number(value) > 0 ? `+${value}` : value
  }

  /**
   * @desc 是否加前缀
   * @param
   * @return {Object} digitjs的实例
   */

  prefix() {
    this.$prefix = true
    return this
  }

  /**
   * @desc 是否保留小数最后的0
   * @param
   * @return {Object} digitjs的实例
   */

  cut() {
    this.$cut = true
    return this
  }

  holder(holder) {
    this.$holder = holder
    return this
  }

  unit(unit) {
    if (unit) {
      this.$unit = i18nTranslateInit.t(unit)
      return this
    } else {
      const absVal = Math.abs(this.$value)
      let name = ''
      let value = 1
      if (absVal >= 1000000000000) {
        name = i18nTranslateInit.t('万亿')
        value = 1000000000000
      } else if (absVal >= 100000000) {
        name = i18nTranslateInit.t('亿')
        value = 100000000
      } else if (absVal >= 10000) {
        name = i18nTranslateInit.t('万')
        value = 10000
      }
      return { name, value }
    }
  }

  colour = (preset) => {
    if (typeof preset === 'object') {
      this.$colour = { ...colour, ...preset }
    }
    return this
  }

  /**
   * @desc 四舍五入
   * @param decimal 需要保留的小数位
   * @return {String} 字符串
   */

  rounded(decimal = 2) {
    if (!this.isNumber(this.$value)) return this.$holder

    let result = this._rounded(this.$value, decimal)

    if (this.$prefix) {
      result = this._prefix(result)
    }

    return result + this.$unit
  }

  /**
   * @desc 单位转换
   * @param decimal 需要保留的小数位
   * @param type 转换类型：0 表示单位转换；1 表示计量转换；其他 表示根据提供的除数进行转换
   * @return {String} 字符串
   */

  convert(decimal = 2, type = 0) {
    if (!this.isNumber(this.$value)) return this.$holder

    const absVal = Math.abs(this.$value)

    let result = this._rounded(this.$value, decimal)
    const needSpaceLang = ['en-us']
    const space = needSpaceLang.includes(i18nTranslateInit.lang) ? ' ' : ''
    let unit = space + this.$unit
    const cnCovert = () => {
      if (absVal >= 1000000000000) {
        result = this._rounded(this.$value / 1000000000000, decimal)
        unit = `${i18nTranslateInit.t('万亿')}${unit}`
      } else if (absVal >= 100000000) {
        result = this._rounded(this.$value / 100000000, decimal)
        unit = `${i18nTranslateInit.t('亿')}${unit}`
      } else if (absVal >= 10000) {
        result = this._rounded(this.$value / 10000, decimal)
        unit = `${i18nTranslateInit.t('万')}${unit}`
      }
    }
    const enCovert = () => {
      if (absVal >= 1000000000) {
        result = this._rounded(this.$value / 1000000000, decimal)
        unit = `B${unit}`
      } else if (absVal >= 1000000) {
        result = this._rounded(this.$value / 1000000, decimal)
        unit = `M${unit}`
      } else if (absVal >= 1000) {
        result = this._rounded(this.$value / 1000, decimal)
        unit = `K${unit}`
      }
    }

    if (type === 0) {
      i18nTranslateInit.lang?.includes('en') ? enCovert() : cnCovert()
    } else if (type === 1) {
      enCovert()
    } else {
      result = this._rounded(this.$value / type, decimal)
    }

    if (this.$prefix) {
      result = this._prefix(result)
    }
    return result + unit
  }

  /**
   * @desc 获取色值
   * @param refer 参考值
   * @return {String} 字符串
   */

  color(refer = 0) {
    let value = +this.$value
    refer = +refer
    if (!this.isNumber(value)) {
      value = 0
    }
    if (!this.isNumber(refer)) {
      refer = 0
    }
    if (value > refer) {
      return this.$colour.up
    } else if (value < refer) {
      return this.$colour.down
    } else {
      return this.$colour.flat
    }
  }

  slice() {
    if (this.isString(this.$value)) {
      return this.$value.slice(...arguments)
    } else {
      return this.$holder
    }
  }

  replace(reg, preset = '') {
    if (this.isString(this.$value)) {
      return this.$value.replace(reg, preset)
    } else {
      return this.$holder
    }
  }

  isNull() {
    const value = this.$value ?? this.$holder
    if (value === this.$holder) {
      return this.$holder
    } else {
      return `${value}${this.$unit}`
    }
  }
}

export default digitjs
